import React from "react";

import { MdmObjectDto, useGetObjectsByProjectQuery } from "gql/generated/types";
import { Link, useNavigate, useParams } from "react-router-dom";
import { TableColumn } from "utils/types";
import ItemsTable from "../components/ItemsTable";

const Objects = () => {
  const { projectId } = useParams();
  const { data, loading } = useGetObjectsByProjectQuery({
    variables: { id: projectId! },
    skip: !projectId,
  });
  const navigate = useNavigate();

  const objectInfoBtn = (rowData: MdmObjectDto) => (
    <Link to={`objects/${rowData.id}`} title="Object Info">
      <i className="pi pi-external-link" />
    </Link>
  );

  const columns: TableColumn<MdmObjectDto>[] = [
    { field: "title", header: "Object Code", sortable: true, filter: true },
    {
      field: "address.fullAddress",
      header: "Address",
      sortable: true,
      filter: true,
    },
    { field: "tags", header: "Tags", body: rowData => rowData.tags?.join(", ") },
    {
      header: "Actions",
      body: objectInfoBtn,
      hideInFile: true,
    },
  ];

  return (
    <div className="card">
      <ItemsTable
        columns={columns}
        data={data?.mdmObjectsByProjectId as MdmObjectDto[]}
        onToolbarBtnClick={() => navigate("objects/new")}
        searchFields={["title", "address.fullAddress", "tags"]}
        toolbarBtnLabel="Add Object"
        tableName="Objects"
        isLoading={loading}
      />
    </div>
  );
};

export default Objects;
